import { authApi } from '@/features/auth';
import { useAuth } from '@/hooks/use-auth';
import { Link, Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/_layout')({
  beforeLoad: async ({ location }) => {
    // Check authentication by attempting to fetch profile
    try {
      const response = await authApi.getProfile();

      if (!response.data?.data) {
        throw redirect({
          to: '/login',
          search: {
            redirect: location.href,
          },
        });
      }

      return { profile: response.data.data };
    } catch (error) {
      // If profile fetch fails, redirect to login
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b bg-white">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <div className="flex items-center gap-8">
            <h1 className="bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-xl font-bold text-transparent">
              Finance
            </h1>
            <nav className="flex gap-4">
              <Link to="/dashboard" className="text-sm hover:text-blue-600">
                Dashboard
              </Link>
              <Link to="/rates" className="text-sm hover:text-blue-600">
                Rates
              </Link>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-600">{user?.email}</span>
            <button
              type="button"
              onClick={() => logout()}
              className="text-sm text-blue-600 hover:underline"
            >
              Logout
            </button>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
